import CourseLabel from './component.jsx'
export default CourseLabel
